import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "mb-10" }
const _hoisted_2 = /*#__PURE__*/_createVNode("h2", { class: "anchor fw-bolder mb-5" }, [
  /*#__PURE__*/_createVNode("a", { href: "#basic-usage" }),
  /*#__PURE__*/_createTextVNode(" Basic usage ")
], -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "py-5" }, " The current value is displayed when the slider is being dragged. ", -1)
const _hoisted_4 = { class: "rounded border p-10" }
const _hoisted_5 = { class: "block" }
const _hoisted_6 = /*#__PURE__*/_createVNode("span", { class: "demonstration" }, "Default value", -1)
const _hoisted_7 = { class: "block" }
const _hoisted_8 = /*#__PURE__*/_createVNode("span", { class: "demonstration" }, "Customized initial value", -1)
const _hoisted_9 = { class: "block" }
const _hoisted_10 = /*#__PURE__*/_createVNode("span", { class: "demonstration" }, "Hide Tooltip", -1)
const _hoisted_11 = { class: "block" }
const _hoisted_12 = /*#__PURE__*/_createVNode("span", { class: "demonstration" }, "Format Tooltip", -1)
const _hoisted_13 = { class: "block" }
const _hoisted_14 = /*#__PURE__*/_createVNode("span", { class: "demonstration" }, "Disabled", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_slider = _resolveComponent("el-slider")
  const _component_CodeHighlighter = _resolveComponent("CodeHighlighter")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createVNode("div", _hoisted_4, [
      _createVNode("div", _hoisted_5, [
        _hoisted_6,
        _createVNode(_component_el_slider, {
          modelValue: _ctx.value1,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.value1 = $event))
        }, null, 8, ["modelValue"])
      ]),
      _createVNode("div", _hoisted_7, [
        _hoisted_8,
        _createVNode(_component_el_slider, {
          modelValue: _ctx.value2,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.value2 = $event))
        }, null, 8, ["modelValue"])
      ]),
      _createVNode("div", _hoisted_9, [
        _hoisted_10,
        _createVNode(_component_el_slider, {
          modelValue: _ctx.value3,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.value3 = $event)),
          "show-tooltip": false
        }, null, 8, ["modelValue"])
      ]),
      _createVNode("div", _hoisted_11, [
        _hoisted_12,
        _createVNode(_component_el_slider, {
          modelValue: _ctx.value4,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.value4 = $event)),
          "format-tooltip": _ctx.formatTooltip
        }, null, 8, ["modelValue", "format-tooltip"])
      ]),
      _createVNode("div", _hoisted_13, [
        _hoisted_14,
        _createVNode(_component_el_slider, {
          modelValue: _ctx.value5,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.value5 = $event)),
          disabled: ""
        }, null, 8, ["modelValue"])
      ]),
      _createVNode(_component_CodeHighlighter, {
        "field-height": 400,
        lang: "html"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.code1), 1)
        ]),
        _: 1
      })
    ])
  ]))
}